import { Box } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { Header } from "../RoutineOccasion/RoutineDetail/Header";
import { IssueStatsCreatedGraph_IssueStats$key } from "./__generated__/IssueStatsCreatedGraph_IssueStats.graphql";
import { YearlyCountStats } from "./YearlyCountStats";
import { FormattedMessage } from "react-intl";

export function IssueStatsCreatedGraph(props: {
  issueStats: IssueStatsCreatedGraph_IssueStats$key;
  rounded?: boolean;
}) {
  const data = useFragment(
    graphql`
      fragment IssueStatsCreatedGraph_IssueStats on IssueStats {
        created {
          count
          date
        }
        resolved {
          count
          date
        }
      }
    `,
    props.issueStats
  );

  return (
    <Box spaceBottom="medium">
      <Box spaceHorizontal={props.rounded ? "none" : "medium"}>
        <Header
          icon="issue"
          subtitle={
            <FormattedMessage
              description="IssueStats Created Graph Subtitle"
              defaultMessage="Number of issues reported each week"
            />
          }
        >
          <FormattedMessage
            description="IssueStats Created Graph Title"
            defaultMessage="Number of issues"
          />
        </Header>
      </Box>

      <Box
        cornerRadius={props.rounded === true ? "medium" : "none"}
        color="surface"
        spaceVertical="medium"
      >
        <YearlyCountStats
          createdData={data.created}
          resolvedData={data.resolved}
        />
      </Box>
    </Box>
  );
}
